import { render, staticRenderFns } from "./TMTransaction.vue?vue&type=template&id=aab1af74"
import script from "./TMTransaction.vue?vue&type=script&lang=js"
export * from "./TMTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports